import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ds-card-meta',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ds-card-meta">
      @for (item of items(); track item) {
        <span class="ds-card-meta__item">{{ item }}</span>
      }
    </div>
  `,
  styles: [`
    .ds-card-meta {
      display: flex;
      flex-wrap: wrap;
      gap: 14px;
      font-family: var(--f-mono);
      font-size: 11px;
      color: currentColor;
      opacity: 0.65;
      letter-spacing: 0.02em;
    }

    .ds-card-meta__item {
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }
  `],
})
export class DsCardMetaComponent {
  readonly items = input<string[]>([]);
}
